import iconList from '../assets/statics/icon-list.json'

const iconsMaterialAPI = {}

iconsMaterialAPI.getAllIcons = () => {
   return iconList
}

export default iconsMaterialAPI
